var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDaBannerColorful = function SvgDaBannerColorful(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 28,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#da-banner-colorful_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "da-banner-colorful_svg__b",
    width: 105,
    height: 28,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M105 0H0v28h105z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF9B01",
    mask: "url(#da-banner-colorful_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.836 10.606c2.736 0 4.118-1.985 4.255-3.94.138-1.928-.89-3.804-3.57-3.804H6.451l-.684 7.743zm.128-1.408h-1.61l.437-4.954h1.607c1.697 0 2.305 1.207 2.232 2.41-.076 1.261-.894 2.544-2.666 2.544M17.484 10.778c2.756 0 4.164-2.003 4.363-4.001.202-2.039-.952-4.07-3.65-4.07-2.7 0-4.201 2.046-4.378 4.08s.908 3.99 3.664 3.99m.12-1.337c-1.842 0-2.413-1.36-2.334-2.632.08-1.304.948-2.787 2.8-2.787 1.853 0 2.457 1.504 2.323 2.776s-.948 2.643-2.79 2.643",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.41 2.85h1.472l-.684 7.752h-.915l-3.647-5.22-.46 5.22h-1.472l.68-7.74h1.198l3.404 4.799z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M32.145 9.14h4.084l.529 1.462h1.61l-2.822-7.74h-1.61l-4.186 7.74h1.595zm.708-1.36 1.744-3.296 1.15 3.296z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.338 4.19H37.86l.108-1.328h6.44l-.12 1.328H41.81l-.564 6.412h-1.469zM44.629 10.602l.683-7.74h1.448l-.684 7.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M51.367 10.778c2.746 0 4.164-2.003 4.363-4.001.199-2.039-.948-4.07-3.65-4.07s-4.197 2.046-4.378 4.08.919 3.99 3.665 3.99m.12-1.337c-1.842 0-2.413-1.36-2.337-2.632.083-1.304.973-2.787 2.815-2.787 1.84 0 2.445 1.504 2.312 2.776-.135 1.271-.948 2.643-2.79 2.643",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.293 2.85h1.472l-.684 7.752h-.915l-3.647-5.22-.46 5.22h-1.472l.68-7.74h1.194L61.87 7.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.062 20.108h4.085l.521 1.465h1.614l-2.819-7.769h-1.606l-4.193 7.77h1.599zm.71-1.364 1.744-3.292 1.15 3.292z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.222 13.804-.575 6.415h4.016l-.109 1.354h-5.492l.688-7.769zM40.421 21.573h-5.85c.232-2.586.46-5.183.688-7.769h5.85l-.127 1.433h-4.385l-.16 1.791h4.23l-.119 1.365h-4.23l-.159 1.748h4.389z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M46.742 21.573h1.75l.022-.111-2.13-2.65a2.58 2.58 0 0 0 2.192-2.443c.12-1.344-.745-2.576-2.587-2.576h-3.716l-.687 7.78h1.447l.242-2.597h1.415zm-3.347-3.918.217-2.486h2.243c.342-.04.683.08.924.322.24.244.354.584.307.92a1.34 1.34 0 0 1-.464.92c-.271.233-.625.35-.984.324z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.032 15.126h-2.486l.12-1.333h6.429l-.112 1.333h-2.479l-.568 6.447h-1.472zM61.652 15.681c-.229-.444-.93-.866-1.777-.866-1.085 0-1.66.455-1.711 1.031-.058.677.723.867 1.657.978 1.61.2 3.093.62 2.927 2.475-.152 1.73-1.758 2.475-3.499 2.475-1.595 0-2.782-.49-3.238-1.909l1.284-.634c.272.856 1.144 1.232 2.092 1.232s1.827-.322 1.899-1.164c.065-.716-.68-1.031-1.708-1.142-1.577-.19-3.014-.613-2.861-2.354.14-1.597 1.783-2.253 3.227-2.264 1.215 0 2.446.359 2.93 1.544z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m85.497.501 5.13 5.932c.203.24.302.55.275.863l-.774 8.772a1.2 1.2 0 0 1-.361.756l-6.332 6.089c-.225.218-.528.34-.843.34h-6.737l-5.937 5.416.463-5.416h-3.017c-.34 0-.663-.14-.892-.389a1.19 1.19 0 0 1-.31-.915l1.835-20.774A1.204 1.204 0 0 1 69.213.082h15.365c.354 0 .69.153.92.42m.079 14.671c.209-.203.338-.474.362-.763l.463-5.42a1.2 1.2 0 0 0-.293-.888l-2.894-3.31c-.23-.26-.563-.41-.912-.411h-9.12a1.21 1.21 0 0 0-1.195 1.103l-1.085 12.178c-.013.144.003.289.046.427a1.2 1.2 0 0 0 1.158.874h8.973c.31 0 .61-.118.836-.33zm-6.793 1.58h-1.77a.36.36 0 0 1-.268-.116.35.35 0 0 1-.094-.274l.156-1.759a.36.36 0 0 1 .362-.33h1.769c.102 0 .2.043.27.118a.36.36 0 0 1 .092.276l-.156 1.755a.36.36 0 0 1-.362.33m-1.5-3.342h1.81a.36.36 0 0 0 .361-.312l.492-5.566a.36.36 0 0 0-.361-.358h-1.81a.36.36 0 0 0-.36.312l-.493 5.566a.36.36 0 0 0 .361.358",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "da-banner-colorful_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h105v28H0z"
  })))));
};
export default SvgDaBannerColorful;